import React from "react";

import { LegalEntityNameChangeStatus } from "../../../../components/LegalEntityNameChangeStatus";
import type { LegalEntityNameChangeState } from "../../../../server/crm/api/models/xboxOnboardModels";
import { PartnerStudioHeader } from "../PartnerStudioHeader";
import * as styles from "../../PartnerHomePage.module.css";

type PartnerStudioCardProps = Readonly<{
  studioName: string | undefined;
  sellerId: string | undefined;
  legalEntityName?: string;
  addressLines?: string[];
  studioPhone?: string;
  legalEntityNameChange?: LegalEntityNameChangeState;
  contactEmail?: string;
  isIdXboxApproved: boolean;
  isEnrollmentComplete: boolean;
  isEnrollmentEarlyComplete: boolean;
  showAgreementsOption: boolean;
  hasAttachedBanner: boolean;
  showDevReadinessGuideOption: boolean;
  showSettingsOption: boolean;
  settingsOnlyMenu?: boolean;
  onShowDevReadinessGuide: () => void;
}>;

export const PartnerStudioCard = ({
  studioName,
  sellerId,
  legalEntityName,
  addressLines,
  studioPhone,
  legalEntityNameChange,
  contactEmail,
  isIdXboxApproved,
  isEnrollmentComplete,
  isEnrollmentEarlyComplete,
  showAgreementsOption,
  hasAttachedBanner,
  showDevReadinessGuideOption,
  showSettingsOption,
  settingsOnlyMenu,
  onShowDevReadinessGuide,
}: PartnerStudioCardProps) => (
  <div
    className={`${styles.card} ${styles.studioCard} ${
      hasAttachedBanner ? styles.cardAttachedBottom : ""
    }`}
  >
    <PartnerStudioHeader
      studioName={studioName}
      sellerId={sellerId}
      legalEntityName={legalEntityName}
      addressLines={addressLines}
      studioPhone={studioPhone}
      isIdXboxApproved={isIdXboxApproved}
      isEnrollmentComplete={isEnrollmentComplete}
      isEnrollmentEarlyComplete={isEnrollmentEarlyComplete}
      showAgreementsOption={showAgreementsOption}
      showDevReadinessGuideOption={showDevReadinessGuideOption}
      showSettingsOption={showSettingsOption}
      settingsOnlyMenu={settingsOnlyMenu}
      onShowDevReadinessGuide={onShowDevReadinessGuide}
    />
    {legalEntityNameChange?.hasActiveRequest && (
      <LegalEntityNameChangeStatus
        state={legalEntityNameChange}
        contactEmail={contactEmail}
        attached
      />
    )}
  </div>
);
